import { render, staticRenderFns } from "./AmenitiesStickyFilter.vue?vue&type=template&id=135eafc1&scoped=true&"
import script from "./AmenitiesStickyFilter.vue?vue&type=script&lang=js&"
export * from "./AmenitiesStickyFilter.vue?vue&type=script&lang=js&"
import style0 from "./AmenitiesStickyFilter.vue?vue&type=style&index=0&id=135eafc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135eafc1",
  null
  
)

export default component.exports